import { useTheme } from "@mui/material";
import { Box } from "@mui/material";
import { ReactNode } from "react";
import { NavLink, NavLinkProps } from "react-router-dom";

export function Tab({
  to,
  children,
  disabled,
  ...props
}: {
  children: ReactNode;
  disabled?: boolean;
} & NavLinkProps) {
  const theme = useTheme();
  return (
    <Box
      to={disabled ? "#" : to}
      component={NavLink}
      sx={{
        width: "212px",
        py: 2,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        cursor: disabled ? "default" : "pointer",
        color: "primary.main",
        position: "relative",
      }}
      style={({ isActive }) => ({
        backgroundColor: disabled
          ? "grey"
          : isActive
          ? theme.palette.secondary.main
          : theme.palette.primary.light,
        color: disabled ? "white" : theme.palette.primary.main,
        textWrap: "nowrap",
      })}
      {...props}
    >
      {children}
    </Box>
  );
}
